module.exports = {
      id: "mxn-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#mxn-usage",
      toString: function () {
        return this.url;
      }
    }